import styled, { css } from 'styled-components';
import {
  PRIMARY_COLOR, PRIMARY_COLOR_ACTIVE, PRIMARY_COLOR_HOVER, SECONDARY_COLOR,
  SECONDARY_COLOR_2,
  SECONDARY_COLOR_3,
  SECONDARY_COLOR_5,
  SECONDARY_COLOR_6
} from '../../const/color';
import { DeleteIcon, UploadIcon, UploadInlineIcon, DragIcon, CenterAligmentIcon } from '../../const/icons';
import { FAMILY_FONT_CONTROL, TITLE_SIZE_5, TITLE_SIZE_6 } from '../../const/text';
import { device } from '../../const/device';


export const BaseItem = styled.div<{ image?: string, name?:string, loading?:string}>`
  width: 100%;
  height: 60px;
  border: 1px dashed ${SECONDARY_COLOR_3};
  border-radius: 4px;
  border-bottom: none;
  position: relative;
  overflow: hidden;
  display:flex;
  align-items:center;
  justify-content: ${props => props.image  ? 'space-between' : 'center'};
  flex-direction:row;
  padding:5px 15px;
  opacity: ${props => props.loading === "true" ? "0.5" : "1"};
  pointer-events: ${props => props.loading === "true" ? "none" : "auto"};
  margin: 5px 0px;

  &:last-child {
  border-bottom: 1px dashed ${SECONDARY_COLOR_3};
}
  
  @media (${device.tablet}) {
    width: 100%;
    height: auto;
    min-height:80px;
  }

  @media (${device.tabletS}) {
    min-height:60px;
  }

  @media (${device.mobileL}) {
    width: 100%;
    height: 44px;
    min-height:auto;
    flex-direction:row;
  }
  
  ${props => props.image ? css`
    display: flex;
    flex-direction: row;
    align-item: center;
    justify-content: center;
    width: 100%;
    &:before {
      content: '';
      display: block;
      width: 30%;
      height: 60%;
      background: url(${props.image}) center / contain no-repeat;
      margin: 0px 40px;

      @media (${device.laptopS}) {
        width: 20%;
        height: 40px;
      }

      @media (${device.tablet}) {
        margin: 0px 20px;
      }

      @media (${device.mobileL}) {
        height: 100%;
      }

    }
    &:after {
      content: '${props.name}';
      display: block;
      width: 40%;
      font-size: 14px;
      font-weight: normal;
      margin-left: -30px;
      margin-right: 55px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap; 

      @media (${device.laptopS}) {
        font-size: 12px;
      }

      @media (${device.tablet}) {
        font-size: 16px;
        margin-left: 0px;
      }

       @media (${device.mobileL}) {
        font-size: 12px;
      }
    }
  ` : css`
    &:after {
      content: 'Upload SVG or PNG format';
      text-align: center;
      display: block;
      color: ${SECONDARY_COLOR_2};
      font-family: ${FAMILY_FONT_CONTROL};
      font-size: ${TITLE_SIZE_5}px;
    }

    @media (${device.tablet}) {
      font-size: 18px;
    }

    @media (${device.mobileL}) {
      &:after {
        content: 'Upload SVG or PNG';
        font-size: ${TITLE_SIZE_6}px;
      }
    }
    
    &:before {
      content: '';
      width: 26px;
      height: 26px;
      display: block;
      border-radius: 50%;
      background: ${SECONDARY_COLOR_6} url("data:image/svg+xml,${UploadIcon()}") center / 22px no-repeat;
      border: 7px solid #F2F4F6;
      margin-right: 15px;

      @media (${device.mobileL}) {
        width: 24px;
        height: 24px;
        margin:0 8px 0 0;
      }
    }
    
    &:hover {
      background-color: ${SECONDARY_COLOR_6};
    }
    
    &:hover:before {
      background-color: white;
      border: 7px solid white;
    }
  `}
`;

export const BaseFileInput = styled.input.attrs({ type: 'file'})`
  position: absolute;
  cursor: pointer;
  width: 100%;
  height: 100%;
  opacity: 0;
  top: 0;
  left: 0;
  z-index: 1;
`;

export const BaseFileRemove = styled.div`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border-radius:2px;
  background:${SECONDARY_COLOR_6} center no-repeat;
  background-image: url("data:image/svg+xml,${DeleteIcon()}");
  z-index: 2;
  cursor: pointer;
`;

export const BaseFileDrag = styled.div`
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  background-image: url("data:image/svg+xml,${DragIcon()}");
  z-index: 2;
  cursor: pointer;
`;

export const InlineFileLoadIco = styled.button`
    width: 48px;
    height: 100%;
    background:${PRIMARY_COLOR} center / 22px no-repeat; 
    background-image: url("data:image/svg+xml,${UploadInlineIcon()}");
    position: absolute;
    right: 0;
    top: 0;
    border: none;
    outline: none;
`;

export const InlineFileRemoveIco = styled.button<{loading?:string}>`
    width: 48px;
    height: 100%;
    background:white center / 22px no-repeat; 
    background-image: url("data:image/svg+xml,${DeleteIcon()}");
    position: absolute;
    right: 0;
    top: 0;
    border: none;
    z-index: 2;
    outline: none;
    opacity: ${props => props.loading === "true" ? "0.5" : "1"};
    pointer-events: ${props => props.loading  === "true" ? "none" : "auto"};

    &:before{
      content: "";
      border-left: 1px solid ${SECONDARY_COLOR_5};
      left: 1px;
      position: absolute;
      height: 70%;
      top: 15%;
    }

    &:hover{
      cursor:pointer;
      background-color:${SECONDARY_COLOR_6}
    }
`;

export const InlineFile = styled.div<{ active?: boolean, placeholder?: string, image?: string }>`
  padding: 11px 59px 11px 16px;
  border: 1px solid ${SECONDARY_COLOR_5};
  border-radius: 2px;
  position: relative;
  cursor: pointer;
  color: ${props => props.active ? SECONDARY_COLOR : SECONDARY_COLOR_2};
  font-family: ${FAMILY_FONT_CONTROL};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  
  @media (${device.mobileL}) {
    font-size: ${TITLE_SIZE_5}px;
    padding: 11px 65px 11px 16px;
  }
  
  ${props => !props.active && css`
    &:before {
      content: 'Upload logo in SVG or PNG format';
    }
  `}

  &:hover{
    ${InlineFileLoadIco}{
      background-color: ${PRIMARY_COLOR_HOVER};
    }
  }

  &:active {
    ${InlineFileLoadIco}{
      background-color: ${PRIMARY_COLOR_ACTIVE};
    }
  }
`;

export const BaseContainer = styled.div<{ minimal: boolean }>`
  position: relative;
  margin-top: 24px;
  
  display: flex;
  flex-direction: column;

  @media (${device.tablet}) {
    margin-top: 32px;
    margin-bottom: 32px;
    min-width: 50%;
  }

  @media (${device.mobileL}) {
    margin-top: 0;
    margin-bottom: 16px;
  }
`;

export const BaseFileCentered = styled.div`
  position: absolute;
  right: 50px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border-radius:2px;
  background:${SECONDARY_COLOR_6} center no-repeat;
  background-image: url("data:image/svg+xml,${CenterAligmentIcon()}");
  z-index: 2;
  cursor: pointer;
`;
